"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfDocument = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var Prescription_1 = require("../Prescription");
var HeaderAndFooter_1 = require("./HeaderAndFooter");
var lodash_2 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var getPatientName = function (patient) {
    if ((0, lodash_1.isEmpty)(patient) === false) {
        var name_1 = patient.name ? patient.name : '';
        return name_1;
    }
    return '';
};
var getPatientAge = function (patient) {
    if ((0, lodash_1.isEmpty)(patient) === false) {
        var years = patient.age
            ? patient.age.years
                ? "".concat(patient.age.years, " years ")
                : ''
            : '';
        var months = patient.age
            ? patient.age.months
                ? "".concat(patient.age.months, " months ")
                : ''
            : '';
        var days = patient.age
            ? patient.age.days
                ? "".concat(patient.age.days, " days")
                : ''
            : '';
        var age = years || months || days ? "".concat(years, " ").concat(months, " ").concat(days) : '';
        return age;
    }
    return '';
};
var getPatientSerial = function (patient) {
    if ((0, lodash_1.isEmpty)(patient) === false) {
        var serialNumber = patient.serialNumber ? patient.serialNumber : '';
        return serialNumber;
    }
    return '';
};
var getMedicine = function (prescriptionData) {
    var medicineList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.medicineEntries) === false) {
        prescriptionData.medicineEntries.forEach(function (medicine) {
            var currentMedicineNameAndSchedule = '';
            currentMedicineNameAndSchedule +=
                (0, Prescription_1.getMedicineName)(medicine.medicine) + '\n';
            currentMedicineNameAndSchedule +=
                (0, Prescription_1.getMedicineSchedule)(medicine.template, medicine) + '\n';
            if ((0, lodash_1.isEmpty)(medicine.multiplePlans) === false) {
                medicine.multiplePlans.forEach(function (multiplePlan) {
                    currentMedicineNameAndSchedule +=
                        (0, Prescription_1.getMedicineSchedule)(medicine.template, multiplePlan) + '\n';
                });
            }
            medicineList.push(currentMedicineNameAndSchedule);
        });
    }
    return medicineList;
};
var getAdviceList = function (prescriptionData) {
    var adviceList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.advices) === false) {
        adviceList.push((0, Prescription_1.getAdvices)(prescriptionData.advices));
    }
    return adviceList;
};
var getInvestigationList = function (prescriptionData) {
    var investigationList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.investigations) === false) {
        investigationList.push((0, Prescription_1.getInvestigations)(prescriptionData.investigations));
    }
    return investigationList;
};
var getFollowupList = function (prescriptionData) {
    var followupList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.followupEntry) === false) {
        followupList.push((0, Prescription_1.getFollowup)(prescriptionData.followupEntry));
    }
    return followupList;
};
var getChiefComplaintList = function (prescriptionData) {
    var complaintList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.chiefComplaints) === false) {
        complaintList.push((0, Prescription_1.getChiefComplaintsorDiagnosis)(prescriptionData.chiefComplaints, 'complaints'));
    }
    return complaintList;
};
var getDiagnosisList = function (prescriptionData) {
    var diagnosisList = [];
    if ((0, lodash_1.isEmpty)(prescriptionData.diagnosis) === false) {
        diagnosisList.push((0, Prescription_1.getChiefComplaintsorDiagnosis)(prescriptionData.diagnosis, 'diagnosis'));
    }
    return diagnosisList;
};
function PdfDocument(props) {
    var prescription = props.prescription;
    var patientName = getPatientName(prescription.patient), patientAge = getPatientAge(prescription.patient), patientSerial = getPatientSerial(prescription.patient), medicineList = getMedicine(prescription.prescriptionData), adviceList = getAdviceList(prescription.prescriptionData), investigationList = getInvestigationList(prescription.prescriptionData), followupList = getFollowupList(prescription.prescriptionData), chiefComplaintList = getChiefComplaintList(prescription.prescriptionData), diagnosisList = getDiagnosisList(prescription.prescriptionData), signatureImage = props.signatureImage;
    var twoColumn = false;
    if (chiefComplaintList.length || diagnosisList.length || investigationList.length)
        twoColumn = true;
    return (react_1.default.createElement("div", { id: "printSection", className: "relative pv4 ph4", style: { overflowY: 'scroll' } },
        react_1.default.createElement("div", { className: "flex justify-end" },
            react_1.default.createElement(core_1.Button, { id: "noprint", className: "ph4", onClick: function () {
                    document.title = patientName.split(' ').join('_');
                    window.print();
                } }, "Print")),
        react_1.default.createElement("div", { className: "cf" },
            react_1.default.createElement("header", null,
                react_1.default.createElement(HeaderAndFooter_1.HeaderSection, { content: props.header })),
            react_1.default.createElement("div", { className: "relative" },
                react_1.default.createElement("div", { className: "bb bt ph2 pv2 mt3" },
                    react_1.default.createElement("div", { className: "flex justify-between" },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "Name:"),
                            " ",
                            patientName),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "Age:"),
                            " ",
                            patientAge),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "Serial ID:"),
                            " ",
                            patientSerial),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("strong", null, "Date:"),
                            " ",
                            (0, moment_1.default)().format('DD/MM/YYYY')))),
                react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' }, className: "f5 w-100 flex" },
                    twoColumn ?
                        react_1.default.createElement("div", { className: "w-30 pr3 br" },
                            chiefComplaintList.length ?
                                react_1.default.createElement("div", { className: "mv2" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("strong", null,
                                            react_1.default.createElement("u", null, "Chief Complaint:"))),
                                    react_1.default.createElement("div", null, chiefComplaintList))
                                :
                                    '',
                            diagnosisList.length ?
                                react_1.default.createElement("div", { className: "mv2" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("strong", null,
                                            react_1.default.createElement("u", null, "Diagnosis:"))),
                                    react_1.default.createElement("div", null, diagnosisList))
                                :
                                    '',
                            investigationList.length ?
                                react_1.default.createElement("div", { className: "mv2" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("strong", null,
                                            react_1.default.createElement("u", null, "Investigation's:"))),
                                    react_1.default.createElement("div", null, investigationList))
                                :
                                    '')
                        :
                            '',
                    react_1.default.createElement("div", { className: twoColumn ? "w-70 pl3" : "w-100" },
                        medicineList.length ?
                            react_1.default.createElement("div", { className: "mv2" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("strong", null,
                                        react_1.default.createElement("u", null, "Medicine's:"))),
                                react_1.default.createElement("div", null, medicineList))
                            :
                                '',
                        adviceList.length ?
                            react_1.default.createElement("div", { className: "mv2" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("strong", null,
                                        react_1.default.createElement("u", null, "Advice's:"))),
                                react_1.default.createElement("div", null, adviceList))
                            :
                                '',
                        followupList.length ?
                            react_1.default.createElement("div", { className: "mv2" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("strong", null,
                                        react_1.default.createElement("u", null, "Follow up:"))),
                                react_1.default.createElement("div", null, followupList))
                            :
                                '')),
                signatureImage ?
                    (0, lodash_2.isEqual)(signatureImage, 'null') ?
                        ''
                        :
                            react_1.default.createElement("div", { className: "flex justify-end" },
                                react_1.default.createElement("img", { src: signatureImage, height: "40", width: "120" }))
                    :
                        ''),
            react_1.default.createElement("footer", { className: "mid-gray w-100 bt tc mt3" },
                react_1.default.createElement(HeaderAndFooter_1.FooterSection, { content: props.footer, doctor: props.doctorName })))));
}
exports.PdfDocument = PdfDocument;
;
//# sourceMappingURL=PDFDocument.js.map